import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/icon/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * Embed generator will generate html code which allows embedding our news feed into different web sites
 * @prop embedUrl - generator will generate an <a> tag, with this href
 * @prop scriptUrl - generator will also generate a script with this src (plus some search params)
 */

export class EmbedGenerator extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    embedUrl: { type: String },
    scriptUrl: { type: String },
    data: { type: Object, state: true },
  };

  constructor() {
    super();
    this.data = {
      notice: 'off',
    };
  }

  /** @internal */
  static translations = translations;

  connectedCallback() {
    super.connectedCallback();
    this.disableFormSubmit();
  }

  disableFormSubmit() {
    this.querySelector('form')?.addEventListener('submit', e =>
      e.preventDefault()
    );
  }

  onInput({ target: { name, value } }) {
    this.data = {
      ...this.data,
      [name]: value || null,
    };
  }

  /** @internal */
  get baseUrl() {
    return window.location.origin;
  }

  /** @internal */
  get scriptFullUrl() {
    return new URL(this.scriptUrl || '', this.baseUrl);
  }

  /** @internal */
  get validData() {
    const validData = {};
    for (const [key, value] of Object.entries(this.data)) {
      if (!(value == null || value.trim?.() === ''))
        validData[key] = value.trim?.() || value;
    }
    return validData;
  }

  /** @internal */
  get timelineUrl() {
    const url = new URL(this.embedUrl || '', this.baseUrl);
    url.search = new URLSearchParams(this.validData);
    return url;
  }

  /** @internal */
  get scriptTag() {
    return `<script src="${this.scriptFullUrl}" async="async"></script>`;
  }

  /** @internal */
  get linkTag() {
    return `<a data-beunity="timeline" href="${this.timelineUrl}">beUnity</a>`;
  }

  /** @internal */
  get strValue() {
    return `${this.linkTag}\n${this.scriptTag}`;
  }

  render() {
    return html`
      <slot @input=${this.onInput}></slot>
      <ef-copy-box-block strValue=${this.strValue}>
        <button>
          ${this.t('copy')}
          <ef-icon name="clipboard-list"></ef-icon>
        </button>
      </ef-copy-box-block>
    `;
  }
}

EmbedGenerator.registerTagName('bu-embed-generator');

customElements.get('bu-embed-generator') ||
  customElements.define('bu-embed-generator', EmbedGenerator);
